class ManifDetail {
    constructor() {
        document.addEventListener(
            "alpine:init",
            () => {
                Alpine.data("manifDetail", () => ({
                    date: {},

                    counters: {},

                    dataStat: {},

                    async init() {
                        window.alpineRender(this);
                        await this.stat();

                        this.initCounter();
                    },

                    async stat() {
                        await window.useHttpApi
                            .get(`/v1/event/stats/${this.date.eventId}`)
                            .then(({ body }) => {
                                this.dataStat = body;
                            })
                            .catch(() => null);
                    },

                    async addCounter() {
                        await window.useHttpApi.patch(
                            `/v1/event/stats/${this.date.eventId}/${this.date.dateId}`,
                        );
                    },

                    async initCounter() {
                        if (
                            window.useSessionStorage?.type ===
                            window.useMemoryStorage?.type
                        ) {
                            return;
                        }

                        const cache = window.useSessionStorage?.get("counters");

                        if (cache) {
                            this.counters = cache;
                            delete this.counters.data;
                        }

                        if (
                            !this.counters[this.date.eventId] ||
                            !this.counters[this.date.eventId][this.date.dateId]
                        ) {
                            await this.addCounter();
                            if (!this.counters[this.date.eventId]) {
                                this.counters[this.date.eventId] = {};
                            }
                            this.counters[this.date.eventId][this.date.dateId] =
                                true;
                            window.useSessionStorage?.set(
                                "counters",
                                this.counters,
                            );
                        }
                    },
                    openCalendar() {
                        this.resetLoading();
                        this.resetError();
                        const dialog = document.querySelector(
                            `[x-ref='dialogDates']`,
                        );

                        if (dialog && !dialog.open) {
                            dialog.showModal();
                        }
                    },

                    back() {
                        if (
                            window.history.length > 1 &&
                            document.referrer.indexOf(window.location.host) >= 0
                        ) {
                            window.history.back();
                        } else {
                            window.location.href = "/";
                        }
                    },
                }));
            },
            { once: true },
        );
    }
}

new ManifDetail();
